module.exports = __webpack_public_path__ + "img/impostor-silhouete-3.bd4f6c08.png";